export default __webpack_public_path__ + "static/media/ele_example_3_1.37af33b3.png";